import * as Yup from "yup";

export default Yup.object().shape({
    service: Yup.string().required("Please enter a service name"),
    cost: Yup.number().min(0, "Please enter a valid positive number").nullable().required("Please enter a cost"),
    unitOfCostId: Yup.number().nullable().required("Please select a Unit Of Cost")
});